export class GitBoardUserServiceSdk {
    caller;
    serverLookup;
    servers;
    constructor(caller, serverLookup, servers = [{ url: 'https://user.api.dev.gitboard.io', variables: { environment: 'dev' } }, { url: 'https://user.api.gitboard.io', variables: { environment: 'prod' } }, { url: 'http://localhost:{port}', variables: { environment: 'local', port: '4000' } }]) {
        this.caller = caller;
        this.serverLookup = serverLookup;
        this.servers = servers;
    }
    server() {
        if (this.servers.length === 0)
            return '';
        const server = !this.serverLookup ? this.servers[0] : this.servers.find(it => Object.keys(this.serverLookup).reduce((result, key) => result && (!this.serverLookup[key] || it.variables[key] === this.serverLookup[key]), true));
        return server ? Object.keys(server.variables).reduce((url, key) => url.replace(`{${key}}`, server.variables[key]), server.url) : '';
    }
    async getAccounts(headers = {}) {
        const resource = '/account';
        const path = `/account`;
        const versionedHeaders = { ...headers, ['X-API-VERSION']: '1.0.0' };
        const props = {
            method: 'GET',
            resource,
            path,
            body: undefined,
            pathParameters: {},
            queryParameters: {},
            multiQueryParameters: {},
            headers: versionedHeaders,
            uri: this.server()
        };
        const result = await this.caller.call(props);
        const resultingVersionKey = Object.keys(result.headers ?? {}).find(it => it.toUpperCase() === 'X-API-VERSION');
        if (resultingVersionKey) {
            const resultingVersion = result.headers[resultingVersionKey];
            if (resultingVersion !== '1.0.0') {
                console.warn(`Version returned from ${path} (${resultingVersion}) does not match requested version 1.0.0`);
            }
        }
        if (result.statusCode === 200) {
            return { statusCode: 200, headers: result.headers, result: JSON.parse(result.body) };
        }
        else if (result.statusCode === 400) {
            return { statusCode: 400, headers: result.headers, result: JSON.parse(result.body) };
        }
        else if (result.statusCode === 401) {
            return { statusCode: 401, headers: result.headers, result: result.body };
        }
        else if (result.statusCode === 403) {
            return { statusCode: 403, headers: result.headers, result: result.body };
        }
        throw new Error(`Unknown status ${result.statusCode} returned from ${path}`);
    }
    async createAccount(body, headers = {}) {
        const resource = '/account';
        const path = `/account`;
        const versionedHeaders = { ...headers, ['X-API-VERSION']: '1.0.0' };
        const props = {
            method: 'POST',
            resource,
            path,
            body: JSON.stringify(body),
            pathParameters: {},
            queryParameters: {},
            multiQueryParameters: {},
            headers: versionedHeaders,
            uri: this.server()
        };
        const result = await this.caller.call(props);
        const resultingVersionKey = Object.keys(result.headers ?? {}).find(it => it.toUpperCase() === 'X-API-VERSION');
        if (resultingVersionKey) {
            const resultingVersion = result.headers[resultingVersionKey];
            if (resultingVersion !== '1.0.0') {
                console.warn(`Version returned from ${path} (${resultingVersion}) does not match requested version 1.0.0`);
            }
        }
        if (result.statusCode === 201) {
            return { statusCode: 201, headers: result.headers, result: JSON.parse(result.body) };
        }
        else if (result.statusCode === 400) {
            return { statusCode: 400, headers: result.headers, result: JSON.parse(result.body) };
        }
        else if (result.statusCode === 401) {
            return { statusCode: 401, headers: result.headers, result: result.body };
        }
        else if (result.statusCode === 403) {
            return { statusCode: 403, headers: result.headers, result: result.body };
        }
        throw new Error(`Unknown status ${result.statusCode} returned from ${path}`);
    }
    async getAccountKey(params, headers = {}) {
        const resource = '/account/{accountId}/key';
        const path = `/account/${params.accountId}/key`;
        const versionedHeaders = { ...headers, ['X-API-VERSION']: '1.0.0' };
        const props = {
            method: 'GET',
            resource,
            path,
            body: undefined,
            pathParameters: params,
            queryParameters: {},
            multiQueryParameters: {},
            headers: versionedHeaders,
            uri: this.server()
        };
        const result = await this.caller.call(props);
        const resultingVersionKey = Object.keys(result.headers ?? {}).find(it => it.toUpperCase() === 'X-API-VERSION');
        if (resultingVersionKey) {
            const resultingVersion = result.headers[resultingVersionKey];
            if (resultingVersion !== '1.0.0') {
                console.warn(`Version returned from ${path} (${resultingVersion}) does not match requested version 1.0.0`);
            }
        }
        if (result.statusCode === 200) {
            return { statusCode: 200, headers: result.headers, result: JSON.parse(result.body) };
        }
        else if (result.statusCode === 400) {
            return { statusCode: 400, headers: result.headers, result: JSON.parse(result.body) };
        }
        else if (result.statusCode === 401) {
            return { statusCode: 401, headers: result.headers, result: result.body };
        }
        else if (result.statusCode === 403) {
            return { statusCode: 403, headers: result.headers, result: result.body };
        }
        throw new Error(`Unknown status ${result.statusCode} returned from ${path}`);
    }
    async deleteUser(params, headers = {}) {
        const resource = '/user/{username}';
        const path = `/user/${params.username}`;
        const versionedHeaders = { ...headers, ['X-API-VERSION']: '1.0.0' };
        const props = {
            method: 'DELETE',
            resource,
            path,
            body: undefined,
            pathParameters: params,
            queryParameters: {},
            multiQueryParameters: {},
            headers: versionedHeaders,
            uri: this.server()
        };
        const result = await this.caller.call(props);
        const resultingVersionKey = Object.keys(result.headers ?? {}).find(it => it.toUpperCase() === 'X-API-VERSION');
        if (resultingVersionKey) {
            const resultingVersion = result.headers[resultingVersionKey];
            if (resultingVersion !== '1.0.0') {
                console.warn(`Version returned from ${path} (${resultingVersion}) does not match requested version 1.0.0`);
            }
        }
        if (result.statusCode === 200) {
            return { statusCode: 200, headers: result.headers, result: result.body };
        }
        else if (result.statusCode === 400) {
            return { statusCode: 400, headers: result.headers, result: JSON.parse(result.body) };
        }
        else if (result.statusCode === 401) {
            return { statusCode: 401, headers: result.headers, result: result.body };
        }
        else if (result.statusCode === 403) {
            return { statusCode: 403, headers: result.headers, result: result.body };
        }
        throw new Error(`Unknown status ${result.statusCode} returned from ${path}`);
    }
    async getPlans(headers = {}) {
        const resource = '/subscription/plan';
        const path = `/subscription/plan`;
        const versionedHeaders = { ...headers, ['X-API-VERSION']: '1.0.0' };
        const props = {
            method: 'GET',
            resource,
            path,
            body: undefined,
            pathParameters: {},
            queryParameters: {},
            multiQueryParameters: {},
            headers: versionedHeaders,
            uri: this.server()
        };
        const result = await this.caller.call(props);
        const resultingVersionKey = Object.keys(result.headers ?? {}).find(it => it.toUpperCase() === 'X-API-VERSION');
        if (resultingVersionKey) {
            const resultingVersion = result.headers[resultingVersionKey];
            if (resultingVersion !== '1.0.0') {
                console.warn(`Version returned from ${path} (${resultingVersion}) does not match requested version 1.0.0`);
            }
        }
        if (result.statusCode === 200) {
            return { statusCode: 200, headers: result.headers, result: JSON.parse(result.body) };
        }
        else if (result.statusCode === 400) {
            return { statusCode: 400, headers: result.headers, result: JSON.parse(result.body) };
        }
        else if (result.statusCode === 401) {
            return { statusCode: 401, headers: result.headers, result: result.body };
        }
        else if (result.statusCode === 403) {
            return { statusCode: 403, headers: result.headers, result: result.body };
        }
        throw new Error(`Unknown status ${result.statusCode} returned from ${path}`);
    }
    async createPlanSession(body, headers = {}) {
        const resource = '/subscription/plan';
        const path = `/subscription/plan`;
        const versionedHeaders = { ...headers, ['X-API-VERSION']: '1.0.0' };
        const props = {
            method: 'POST',
            resource,
            path,
            body: JSON.stringify(body),
            pathParameters: {},
            queryParameters: {},
            multiQueryParameters: {},
            headers: versionedHeaders,
            uri: this.server()
        };
        const result = await this.caller.call(props);
        const resultingVersionKey = Object.keys(result.headers ?? {}).find(it => it.toUpperCase() === 'X-API-VERSION');
        if (resultingVersionKey) {
            const resultingVersion = result.headers[resultingVersionKey];
            if (resultingVersion !== '1.0.0') {
                console.warn(`Version returned from ${path} (${resultingVersion}) does not match requested version 1.0.0`);
            }
        }
        if (result.statusCode === 200) {
            return { statusCode: 200, headers: result.headers, result: JSON.parse(result.body) };
        }
        else if (result.statusCode === 400) {
            return { statusCode: 400, headers: result.headers, result: JSON.parse(result.body) };
        }
        else if (result.statusCode === 401) {
            return { statusCode: 401, headers: result.headers, result: result.body };
        }
        else if (result.statusCode === 403) {
            return { statusCode: 403, headers: result.headers, result: result.body };
        }
        throw new Error(`Unknown status ${result.statusCode} returned from ${path}`);
    }
    async verifyPlan(body, headers = {}) {
        const resource = '/subscription/plan/verify';
        const path = `/subscription/plan/verify`;
        const versionedHeaders = { ...headers, ['X-API-VERSION']: '1.0.0' };
        const props = {
            method: 'POST',
            resource,
            path,
            body: JSON.stringify(body),
            pathParameters: {},
            queryParameters: {},
            multiQueryParameters: {},
            headers: versionedHeaders,
            uri: this.server()
        };
        const result = await this.caller.call(props);
        const resultingVersionKey = Object.keys(result.headers ?? {}).find(it => it.toUpperCase() === 'X-API-VERSION');
        if (resultingVersionKey) {
            const resultingVersion = result.headers[resultingVersionKey];
            if (resultingVersion !== '1.0.0') {
                console.warn(`Version returned from ${path} (${resultingVersion}) does not match requested version 1.0.0`);
            }
        }
        if (result.statusCode === 200) {
            return { statusCode: 200, headers: result.headers, result: JSON.parse(result.body) };
        }
        else if (result.statusCode === 400) {
            return { statusCode: 400, headers: result.headers, result: JSON.parse(result.body) };
        }
        else if (result.statusCode === 401) {
            return { statusCode: 401, headers: result.headers, result: result.body };
        }
        else if (result.statusCode === 403) {
            return { statusCode: 403, headers: result.headers, result: result.body };
        }
        throw new Error(`Unknown status ${result.statusCode} returned from ${path}`);
    }
}
export * from './model';
